
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export const useNavigationUtils = () => {
  const location = useLocation();
  const { currentLanguage } = useLanguage();

  // Map service pages to their correct paths
  const servicePages = [
    { key: 'productVideos', path: 'product-videos' },
    { key: 'socialMediaAds', path: 'social-media-ads' }
  ];

  // Service paths by language
  const servicePaths = {
    de: {
      'product-videos': 'leistungen/produktvideos',
      'social-media-ads': 'leistungen/social-media-ads',
      'why-future-level': 'warum-future-level',
      'contact': 'kontakt'
    },
    en: {
      'product-videos': 'services/product-videos',
      'social-media-ads': 'services/social-media-ads',
      'why-future-level': 'why-future-level',
      'contact': 'contact'
    },
    fr: {
      'product-videos': 'services/videos-de-produits',
      'social-media-ads': 'services/publicites-medias-sociaux',
      'why-future-level': 'pourquoi-future-level',
      'contact': 'contact'
    },
    it: {
      'product-videos': 'servizi/video-di-prodotti',
      'social-media-ads': 'servizi/pubblicita-social-media',
      'why-future-level': 'perche-future-level',
      'contact': 'contatto'
    }
  };

  // Check if current path includes service path
  const isServiceActive = (path: string) => {
    const currentPath = location.pathname.toLowerCase();
    return servicePaths[currentLanguage as keyof typeof servicePaths][path] && 
           currentPath.includes(servicePaths[currentLanguage as keyof typeof servicePaths][path]);
  };

  // Get the localized path for a service
  const getServicePath = (path: string) => {
    return `/${currentLanguage}/${servicePaths[currentLanguage as keyof typeof servicePaths][path]}`;
  };

  // Check if why-future-level page is active
  const isWhyFutureLevelActive = () => {
    const currentPath = location.pathname.toLowerCase();
    const whyFutureLevelPath = servicePaths[currentLanguage as keyof typeof servicePaths]['why-future-level'];
    return currentPath.includes(whyFutureLevelPath);
  };

  // Get the localized path for why-future-level
  const getWhyFutureLevelPath = () => {
    return `/${currentLanguage}/${servicePaths[currentLanguage as keyof typeof servicePaths]['why-future-level']}`;
  };

  // Check if contact page is active
  const isContactActive = () => {
    const currentPath = location.pathname.toLowerCase();
    const contactPath = servicePaths[currentLanguage as keyof typeof servicePaths]['contact'];
    return currentPath.includes(contactPath);
  };

  // Get the localized path for contact
  const getContactPath = () => {
    return `/${currentLanguage}/${servicePaths[currentLanguage as keyof typeof servicePaths]['contact']}`;
  };

  return {
    servicePages,
    isServiceActive,
    getServicePath,
    isWhyFutureLevelActive,
    getWhyFutureLevelPath,
    isContactActive,
    getContactPath
  };
};
